import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../core';
import { ClienteSearchMatriz } from '../matriz';

@Injectable({
    providedIn: 'root'
})
export class ClienteMatrizHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pessoa`;
    }

    /** Pesquisa os clientes vinculados a mesma matriz do cliente informado */
    search(idPessoa: number, idRepresentante: number, incluirMatriz: boolean): Observable<ClienteSearchMatriz[]> {
        // Params
        let params = new HttpParams();
        // Representante
        params = params.append('idRepresentante', idRepresentante ? idRepresentante.toString() : null);
        // Incluir Matriz
        params = params.append('incluirMatriz', incluirMatriz ? incluirMatriz.toString() : null);

        return this.customHttp.get<ClienteSearchMatriz[]>(`${this.pathApi}/${idPessoa}/matriz`, {params});
    }
}
